import React, { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaSearch } from 'react-icons/fa';

const EcontOfficeSelector = ({
  selectedCityId,
  setSelectedCityId,
  cities,
  filteredOffices,
  selectedOffice,
  setSelectedOffice
}) => {
  const [cityDropdownOpen, setCityDropdownOpen] = useState(false);
  const [officeDropdownOpen, setOfficeDropdownOpen] = useState(false);
  const [citySearchTerm, setCitySearchTerm] = useState('');
  const [officeSearchTerm, setOfficeSearchTerm] = useState('');
  
  // Filter cities based on search term
  const filteredCities = cities.filter(city => {
    const cityName = city.name?.toLowerCase() || '';
    const regionName = (city.region || city.regionName || '').toLowerCase();
    const searchTerm = citySearchTerm.toLowerCase();
    
    return cityName.includes(searchTerm) || regionName.includes(searchTerm);
  });
  
  // Filter offices based on search term
  const searchFilteredOffices = filteredOffices.filter(office => {
    const officeAddress = (office.address || office.office_address || '').toLowerCase();
    const searchTerm = officeSearchTerm.toLowerCase();
    
    return officeAddress.includes(searchTerm);
  });
  
  // Reset search terms when dropdowns close
  useEffect(() => {
    if (!cityDropdownOpen) setCitySearchTerm('');
    if (!officeDropdownOpen) setOfficeSearchTerm('');
  }, [cityDropdownOpen, officeDropdownOpen]);

  return (
    <div className="mt-2">
      <div className="flex items-center mb-3">
        <FaMapMarkerAlt className="text-amber-500 mr-2" />
        <span className="font-medium text-sm">ИЗБЕРИ ОФИС</span>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="relative">
          <input
            type="text"
            placeholder="Населено място"
            value={selectedCityId ? cities.find(c => c.city_id === selectedCityId)?.name || '' : ''}
            onClick={() => setCityDropdownOpen(true)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary cursor-pointer"
            readOnly
          />
          {cityDropdownOpen && (
            <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
              <div className="sticky top-0 bg-white p-2 border-b">
                <div className="relative">
                  <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Търси населено място..."
                    value={citySearchTerm}
                    onChange={(e) => setCitySearchTerm(e.target.value)}
                    className="w-full pl-9 pr-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                    onClick={(e) => e.stopPropagation()}
                    autoFocus
                  />
                </div>
              </div>
              
              {filteredCities.length === 0 ? (
                <div className="px-4 py-3 text-gray-500 text-center">Няма намерени резултати</div>
              ) : (
                filteredCities.map(city => (
                  <div 
                    key={city.city_id} 
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      setSelectedCityId(city.city_id);
                      setSelectedOffice(null);
                      setCityDropdownOpen(false);
                    }}
                  >
                    {city.region || city.regionName} ({city.name})
                  </div>
                ))
              )}
            </div>
          )}
        </div>
        <div className="relative">
          <input
            type="text"
            placeholder="Избери офис"
            value={selectedOffice ? (selectedOffice.address || selectedOffice.office_address) : ''}
            onClick={() => selectedCityId && setOfficeDropdownOpen(true)}
            className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary ${selectedCityId ? 'cursor-pointer' : 'cursor-not-allowed bg-gray-50'}`}
            readOnly
            disabled={!selectedCityId}
          />
          {officeDropdownOpen && selectedCityId && (
            <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
              <div className="sticky top-0 bg-white p-2 border-b">
                <div className="relative">
                  <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Търси офис..."
                    value={officeSearchTerm}
                    onChange={(e) => setOfficeSearchTerm(e.target.value)}
                    className="w-full pl-9 pr-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                    onClick={(e) => e.stopPropagation()}
                    autoFocus
                  />
                </div>
              </div>
              
              {searchFilteredOffices.length === 0 ? (
                <div className="px-4 py-3 text-gray-500 text-center">Няма намерени офиси</div>
              ) : (
                searchFilteredOffices.map(office => (
                  <div 
                    key={office.office_id || office.id} 
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      setSelectedOffice(office);
                      setOfficeDropdownOpen(false);
                    }}
                  >
                    {office.address || office.office_address}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EcontOfficeSelector; 